import { render, staticRenderFns } from "./sub-icon-item--rounded.vue?vue&type=template&id=2f08f71f&scoped=true&"
import script from "./sub-icon-item--rounded.vue?vue&type=script&lang=js&"
export * from "./sub-icon-item--rounded.vue?vue&type=script&lang=js&"
import style0 from "./sub-icon-item--rounded.vue?vue&type=style&index=0&id=2f08f71f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f08f71f",
  null
  
)

export default component.exports